import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import global from "global";
import { ServiceError, SdkError } from "../errors";
import { ITEM_TO_BAG_ERROR_TIMEOUT } from "../../state/modules/savedItems/constants";
import isBagServiceError from "./isBagServiceError";

export default ({ toBagOperation, requestTimeout }) =>
  async item => {
    const sdkInstance = await sdkInstanceProvider("bag");

    let timeout;

    return await Promise.race([
      new Promise((_, reject) => {
        timeout = global.setTimeout(() => {
          reject(new ServiceError(new Error(ITEM_TO_BAG_ERROR_TIMEOUT)));
        }, requestTimeout);
      }),
      (async () => {
        try {
          return await toBagOperation(sdkInstance, item);
        } catch (e) {
          if (isBagServiceError(e)) {
            throw new ServiceError(e);
          }
          throw new SdkError(e);
        } finally {
          global.clearTimeout(timeout);
        }
      })()
    ]);
  };
